import { Injectable } from '@angular/core';

@Injectable()
  export class GlobalsTxt {
    textosSso: any ;
    language = 'es';
}
